<template>
  <div>

    <div class="sayfahead">
      <h1>{{SayfaAdi}}</h1>

      <el-button-group v-if="Liste" class="float-right">

        <el-button type="success" size="small" class="YeniBtn" @click="Excel"
                   icon="el-icon-download">Excel İndir
        </el-button>
        <a @click="Yazdir" class="el-button YeniBtn el-button--primary el-button--small"
        ><i class="feather-printer"></i> Yazdır
        </a>

      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">
          <el-form
            :rules="FormHata"
            @submit.prevent.native="Calistir"
            ref="RaporForm">
            <el-col :span="4">
              <el-form-item label="Site / Bina" prop="Bina_id">
                <el-select v-model="Bina_id" filterable>
                  <el-option
                    v-for="item in Binalar"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Talep Türü" prop="Tur">
                <el-select v-model="Tur" filterable>
                  <el-option
                    value="1"
                    label="Oturanlar">
                  </el-option>
                  <el-option
                    value="2"
                    label="Mesken Sahipleri">
                  </el-option>
                  <el-option
                    value="3"
                    label="Tümü">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Bilgi" class="Tooltip" prop="Bilgi">
                <el-tooltip class="item" effect="dark"
                            content="Raporda ekstra gösterilmesini istediğiniz bilgileri seçiniz"
                            placement="top">
                  <i class="el-icon-info text-primary cursor-pointer"></i>
                </el-tooltip>
                <el-select
                  v-model="Bilgi"
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  placeholder="Seçiniz">
                  <el-option
                    v-for="item in BilgiList"
                    :key="item.value"
                    :label="item.baslik"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="3" :offset="1">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Calistir"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <el-alert
        v-if="!Liste"
        title="Filtreleme Yapınız"
        type="info"
        :closable="false"
        class="yazdirma"
        description="Verilere erişebilemek için lütfen filtreleme yapınız"
      >
      </el-alert>
      <table v-if="Liste" class="table table-bordered table-hover yazdirma">
        <thead>
        <tr>
          <th v-if="BilgiData.Bina">Bina Adı</th>
          <th>İsim Soyisim</th>
          <th v-if="BilgiData.Sahip">Mülk</th>
          <th v-if="BilgiData.Kat">Kat</th>
          <th v-if="BilgiData.kNo">Mesken No</th>
          <th v-if="BilgiData.m2">M2</th>
          <th v-if="BilgiData.vNo">Kimlik No</th>
          <th v-if="BilgiData.Telefon">Telefon</th>
          <th v-if="BilgiData.Mail">Mail Adresi</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="l in Liste">
          <td v-if="BilgiData.Bina">{{l.BinaAdi}}</td>
          <td>{{l.AdSoyad}}</td>
          <td v-if="BilgiData.Sahip">{{l.Sahip=='1'?'Mesken Sahibi':'Kiracı'}}</td>
          <td v-if="BilgiData.Kat">{{l.Kat}}</td>
          <td v-if="BilgiData.kNo">{{l.kNo}}</td>
          <td v-if="BilgiData.m2">{{l.m2}}</td>
          <td v-if="BilgiData.vNo">{{l.vNo}}</td>
          <td v-if="BilgiData.Telefon">{{l.Telefon}}</td>
          <td v-if="BilgiData.Mail">{{l.Mail}}</td>
        </tr>
        </tbody>
      </table>
      <div class="yazdirtable">
        <h1>{{SayfaAdi}}</h1>
        <table v-if="Liste" class="table table-bordered table-hover">
          <thead>
          <tr>
            <th v-if="BilgiData.Bina">Bina Adı</th>
            <th>İsim Soyisim</th>
            <th v-if="BilgiData.Sahip">Mülk</th>
            <th v-if="BilgiData.Kat">Kat</th>
            <th v-if="BilgiData.kNo">Mesken No</th>
            <th v-if="BilgiData.m2">M2</th>
            <th v-if="BilgiData.vNo">Kimlik No</th>
            <th v-if="BilgiData.Telefon">Telefon</th>
            <th v-if="BilgiData.Mail">Mail Adresi</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="l in Liste">
            <td v-if="BilgiData.Bina">{{l.BinaAdi}}</td>
            <td>{{l.AdSoyad}}</td>
            <td v-if="BilgiData.Sahip">{{l.Sahip=='1'?'Mesken Sahibi':'Kiracı'}}</td>
            <td v-if="BilgiData.Kat">{{l.Kat}}</td>
            <td v-if="BilgiData.kNo">{{l.kNo}}</td>
            <td v-if="BilgiData.m2">{{l.m2}}</td>
            <td v-if="BilgiData.vNo">{{l.vNo}}</td>
            <td v-if="BilgiData.Telefon">{{l.Telefon}}</td>
            <td v-if="BilgiData.Mail">{{l.Mail}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import Yukleniyor from "../../../components/Doc/Yukleniyor";
  import Table from "../../../components/Pack/Table";
  import XLSX from 'xlsx';

  const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
    name: XLSX.utils.encode_col(i),
    key: i
  }));

  export default {
    components: {Table, Yukleniyor},
    data() {
      return {
        lo: false,
        Tur: '1',
        tableDisplay: false,
        SayfaAdi: 'Kişi Listesi',
        Liste: null,
        Binalar: null,
        ExcelData: null,
        Bina_id: null,
        Bilgi: ['Telefon'],
        BilgiData: [],
        FormHata: {
          Bilgi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
        BilgiList: [
          {baslik: 'Bina Adı', value: 'Bina'},
          {baslik: 'Sahip/Kiracı', value: 'Sahip'},
          {baslik: 'Telefon', value: 'Telefon'},
          {baslik: 'Kimlik No', value: 'vNo'},
          {baslik: 'Kat', value: 'Kat'},
          {baslik: 'Mesken No', value: 'kNo'},
          {baslik: 'M2', value: 'm2'},
          {baslik: 'E-Mail', value: 'Mail'},

        ],
      }
    },
    methods: {
      Excel(evt) {

        const ws = XLSX.utils.json_to_sheet(this.ExcelData);
        const wb = XLSX.utils.book_new();
        ws['!cols'] = [
          {wch: 25},
          {wch: 25},
          {wch: 12},
          {wch: 10},
          {wch: 10},
          {wch: 10},
          {wch: 25},
          {wch: 25},
          {wch: 25},
        ];

        wb.Props = {
          Title: this.SayfaAdi,
          Author: "Aidatim APP",
          Manager: "Aidatim APP",
          Company: "Aidatim",
          Category: "Finans",
          Keywords: "Aidatim",
          Comments: this.SayfaAdi,
        };
        XLSX.utils.book_append_sheet(wb, ws, this.SayfaAdi);
        XLSX.writeFile(wb, this.SayfaAdi + ".xlsx");
      },
      Yazdir() {
        this.$prompt('Yazdırılacak sayfanın adını değişebilirsiniz.', 'Sayfa Adı', {
          confirmButtonText: 'Yazıcıya Gönder',
          cancelButtonText: 'Vazgeç',
          inputValue: this.SayfaAdi,
          inputPlaceholder: 'Yazdırma Sayfası'
        }).then(({value}) => {
          this.SayfaAdi = value;
          this.YaziciyaGonder(value);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Yazdırma İptal Edildi'
          });
        });
      },
      YaziciyaGonder() {
        setTimeout(() => {
          window.print();
        }, 100);
      },
      SayfaYukle() {
        this.$store.dispatch("Get", {path: 'muhasebe/list/bina'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Binalar = response.Liste

            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },
      Calistir() {
        this.lo = true;
        this.$store.dispatch("Post", {
          Bilgi: this.Bilgi,
          Bina_id: this.Bina_id,
          Tur: this.Tur,
          path: 'raporlama/ozel/kisilist'
        })
          .then(response => {
            this.lo = false;
            if (response.Durum == "OK") {
              this.Liste = response.Liste;
              this.ExcelData = response.ExcelData
              this.BilgiData = response.BilgiData
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          })
      }
    },
    created() {
      if (this.$store.getters.BinaBilgi) {
        this.Bina_id = this.$store.getters.BinaBilgi.id;
      }
      this.SayfaYukle();
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Raporlama/ozel/kisilistesi.vue